import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import styles from './PropertyListingCard.module.scss';
import { Field, ImageField, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import { useI18n } from 'next-localization';

export type PropertyData = {
  image: ImageField;
  title: Field<string>;
  details: Field<string>;
  occupationalTenancies: Field<string>;
  ownership?: {
    fields?: {
      title?: Field<string>;
    };
  };
};

type Props = {
  fields: PropertyData;
  category?: string;
  className: string;
};

const PropertyListingsCard: React.FC<Props> = ({ fields, category = '', className }) => {
  const ownership = fields?.ownership?.fields?.title?.value || '';
  const { t } = useI18n();
  return (
    <div className={className}>
      <div className={styles.listingCard}>
        <div className={`${styles.listingCardThumbnail} flex-shrink-0 position-relative`}>
          <NextImage
            field={fields.image}
            sizes="
              (max-width: 575px) 100vw,
              (max-width: 767px) 510px,
              (max-width: 991px) 330px,
              (max-width: 1199px) 25vw,
              270px
            "
            fill
            style={{ objectFit: 'cover' }}
          />
        </div>

        <div
          className={`${styles.listingCardBody} py-2 px-2 flex-grow-1 ${
            ownership ? 'vectorBasedBackground' : ''
          }`}
        >
          <div className="d-flex align-items-start section-header-small">
            <span className="section-header-small">{category}</span>
          </div>

          <div className={`${styles.listingCardContent} my-2`}>
            <Text tag="h5" className="line-clamp-2" field={fields.title} />
            <div className={`${styles.bodySmall} text-grey mt-2`}>
              <p>
                <span>{t('propertyCardDetailsLabel')}</span> -{' '}
                <Text tag="span" field={fields.details} />
              </p>
              <p>
                <span>{ownership}</span>
              </p>
              <p>
                <span>{t('propertyCardOccupationalTenanciesLabel')}</span> -{' '}
                <Text tag="span" field={fields.occupationalTenancies} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyListingsCard;
